module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('van-pull-refresh', {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, [_c('div', {
    staticClass: "top-box"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "border-radius": "5px",
      "border": "1px solid #00B388",
      "width": "3.3rem",
      "margin": "10px auto",
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticClass: "top-left",
    style: (_vm.active == 1 ? 'background: #00B388;color: #fff;' : 'background: #fff;color: #00B388;'),
    on: {
      "click": _vm.onBrowse
    }
  }, [_vm._v("浏览历史")]), _vm._v(" "), _c('div', {
    staticClass: "top-right",
    style: (_vm.active == 2 ? 'background: #00B388;color: #fff;' : 'background: #fff;color: #00B388;'),
    on: {
      "click": _vm.onBuy
    }
  }, [_vm._v("已购买")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "7.1rem",
      "margin": "0 auto"
    }
  }, _vm._l((_vm.courseList), function(item, i) {
    return _c('div', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'CourseDetail',
          query: {
            id: item.course_id
          }
        }),
        expression: "{name:'CourseDetail',query:{id:item.course_id}}"
      }],
      key: i,
      staticClass: "course-items"
    }, [_c('img', {
      attrs: {
        "src": item.pic_url,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "course-info"
    }, [_c('p', {
      staticClass: "p1"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticClass: "p2"
    }, [_vm._v(_vm._s(item.times))]), _vm._v(" "), _c('p', {
      staticClass: "p3"
    }, [_vm._v(_vm._s(item.pay_price))])])])
  }), 0)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4528ba6e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/course/MyCourseList.vue
// module id = 2346
// module chunks = 0